<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/project' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/project/detail?id=${query.id}` }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}项目支出</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="base1">
      <h3 class="ntitle">合同信息</h3>
      <ul>
        <li>
          <p>
            <label>合同类型：</label><a>{{ dd.contract_type[form.contract_type] }}</a>
          </p>
          <p>
            <label>合同金额：</label><a>{{ form.contract_amount }}</a>
          </p>
          <p>
            <label>税率：</label><a>{{ form.tax_rate }}%</a>
          </p>
          <p>
            <label>电子合同附件：</label>
            <template>
              <ul class="bbox">
                <li v-for="(item, index) in fileList" :key="index">
                  <el-col :span="24" v-if="fileList[0].origin_name">
                    <el-col :span="20">
                      <div class="origin-name">{{ item.origin_name }}</div>
                    </el-col>
                    <el-col :span="4">
                      <el-link type="primary" style="margin-right:5px" :href="item.httpFile" target="_blank">查看</el-link>
                    </el-col>
                  </el-col>
                  <el-col :span="24" v-else> 暂无电子合同 </el-col>
                </li>
              </ul>
            </template>
          </p>
          <p>
            <label>盖章合同附件：</label>
            <template>
              <ul class="bbox">
                <li v-for="(item, index) in fileList1" :key="index">
                  <el-col :span="24" v-if="fileList1[0].origin_name">
                    <el-col :span="20">
                      <div class="origin-name">{{ item.origin_name }}</div>
                    </el-col>
                    <el-col :span="4">
                      <el-link type="primary" style="margin-right:5px" :href="item.httpFile" target="_blank">查看</el-link>
                    </el-col>
                  </el-col>
                  <el-col :span="24" v-else> 暂无盖章合同 </el-col>
                </li>
              </ul>
            </template>
          </p>
        </li>
        <li>
          <p>
            <template v-if="form.contract_type == 3">
              <label>所属合同：</label>
              <a @click="link(`/project/detail?id=${form.parent_project_id}`)" style="cursor: pointer;">{{
                form.parentContractNo }}</a>
            </template>
          </p>
          <p>
            <label>合同时间：</label><a>{{ form.contract_start_time }} —— {{ form.contract_end_time }}</a>
          </p>
          <p>
            <label>税额：</label><a>{{ form.tax }}</a>
          </p>
        </li>
      </ul>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">子项目信息</div>
        <ul class="anlist">
          <li v-for="(item, index) in sonList" :key="index">
            <div class="abox">
              <el-form-item label="子项目名称：" prop="son_contract_name">
                <el-col :span="12">
                  <el-input placeholder="请输入" maxlength="100" v-model="item.contract_name" clearable
                    :disabled="form.status == '5'" />
                </el-col>
              </el-form-item>
              <el-form-item label="项目起止时间：" prop="son_contract_time">
                <el-col :span="12">
                  <el-date-picker v-model="item.son_contract_time" type="datetimerange" range-separator="--"
                    start-placeholder="项目开始时间" end-placeholder="项目结束时间" style="width:100%;" @blur="sonContractTime(index)"
                    :disabled="form.status == '5'">
                  </el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="项目金额：" prop="son_amount">
                <el-col :span="12">
                  <el-input placeholder="请输入" maxlength="100" v-model="item.amount" clearable @input="amountChange"
                    :disabled="form.status == '5'" />
                </el-col>
              </el-form-item>
              <el-form-item label="选择收款计划：" prop="son_bill_id">
                <el-col :span="12">
                  <el-select v-model="item.sonBillList" placeholder="请选择" @remove-tag="(v) => removeTag(v, item)" @change="(v) => changeBillIdList(v, item)" style="margin-right: 0; width: 100%;" filterable multiple value-key="id" :disabled="form.status == '5'">
                    <el-option v-for="v in billList" :key="v.id" :label="`${v.bill_name}-金额：${v.amount}`" :value="v" :disabled="v.chosed"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </div>
            <el-button class="abtn" v-if="form.status != '5'" icon="el-icon-minus"
              @click="removeSon(sonList, index)" circle></el-button>
          </li>
          <el-button type="primary" style="margin: 0 0 15px -5px" class="addbtn" v-if="form.status != '5'" @click="addSon(sonList)">新增子项目</el-button>
        </ul>
        <el-form-item label="剩余待分配金额：" prop="amount_left">
          <el-col :span="12">
            <el-input maxlength="100" v-model="amount_left" disabled clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="">
          <el-col :span="10">
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import * as api from '@/api'
import { timeFormat } from '@/utils/index.js'
export default {
  name: 'proSon',
  data() {
    return {
      nodeLimtList: [],
      clientList: [],
      userList: [],
      projectList: [],
      brandArr: {
        brandList: []
      },
      form: {
        project_id: '',
        //合同信息
        contract_no: '',
        contract_type: '',
        parent_project_id: '',
        contract_time: ['', ''],
        contract_start_time: '',
        contract_end_time: '',
        contract_amount: '',
        tax_rate: '6',
        tax: '',
        info: '',
        atta_str: '', //合同附件数组, file_type 1电子合同 2盖章合同
        atta_del: '', //删除的文件id(用英文,隔开 如: 13,14,15)
        //项目信息-收款计划
        son_str: '',
        son_del: '',
      },
      sonList: [
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', },
      ],
      billList: [
        { amount: '', bill_name: '', type: '1', bill_id: '', bill_day: '', bill_date: '', estimate_date: '', }//bill_id 计划id 新增为0，编辑不为空
      ],
      billListCheck: [],
      amount_left: '0.00', //项目剩余金额
      del_son_list: [],
      rules: {

      },
      fileList: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      fileList1: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      del_atta_list: [],
      del_atta_list1: [],
      totalPlanAmount: 0,
    }
  },
  created() {
    this.query = this.$route.query
    this.query.id && this.getDetail(this.query.id)
  },
  mounted() {

  },
  watch: {
    ['form.pay_bank_account'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.pay_bank_account = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& ');
        });
      }
    }
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    addSon(arr) {
      arr.push({
        contract_name: '',
        son_contract_time: [],
        start_time: '',
        end_time: '',
        amount: '',
      });
    },
    removeSon(arr, index) {
      if (arr[index].payList && arr[index].payList.length > 0) {
        this.$message.error('请清空子项目支付计划后再进行操作!')
        return false
      }
      this.del_son_list.push(arr[index].id);
      console.log(this.del_son_list);
      arr = arr.splice(index, 1);
    },
    amountChange() {//项目剩余金额计算
      const total = Number(this.totalPlanAmount)
      // const total = Number(this.form.contract_amount)
      let temp = 0
      this.sonList.forEach(item => {
        temp += Number(item.amount)
      })
      const amount_left = (total - temp)
      console.log('total:',total, 'temp:',temp, 'amount_left:',amount_left,);
      if (amount_left >= 0) {
        this.amount_left = amount_left.toFixed(2)//取两位
      }
      else {
        this.amount_left = '项目剩余金额为负,请重新填写'
      }
    },
    //子项目时间调整
    sonContractTime(index) {
      this.$forceUpdate()
      const time = this.sonList[index].son_contract_time
      this.sonList[index].start_time = this.fdate(time[0])
      this.sonList[index].end_time = this.fdate(time[1])
    },
    containsDuplicate(arr, key) {
      for (let k = 1; k < arr.length; k++) {
        if (arr[k][key] === arr[k - 1][key]) {
          return true;
        }
      }
      return false;
    },
    async getDetail(id) {
      this.checkUrlFn()
      this.$fly
        .post('apiProject_getDetail.html', {
          project_id: id,
        })
        .then((res) => {
          let form = res.itemArr
          this.totalPlanAmount = res.totalPlanAmount
          delete form.is_apply
          //修改0000-00-00错误显示1899年情况
          form.contract_start_time = timeFormat(form.contract_start_time)
          form.contract_end_time = timeFormat(form.contract_end_time)
          form.finish_time = timeFormat(form.finish_time)
          //初始contract_time
          form.contract_time = ['', '']
          form.contract_time[0] = form.contract_start_time
          form.contract_time[1] = form.contract_end_time
          this.sonList = res.sonList.filter(item => item.id).map((item) => {
            item.chosed = item.son_project_id > 0 ? true : false
            item.start_time = timeFormat(item.start_time)
            item.end_time = timeFormat(item.end_time)            
            item.son_contract_time = []
            item.son_contract_time[0] = timeFormat(item.start_time)
            item.son_contract_time[1] = timeFormat(item.end_time)
            return item
          })
          this.billList = res.billList.map((item) => {
            item.bill_date = timeFormat(item.bill_date)
            item.estimate_date = timeFormat(item.estimate_date)
            item.chosed = item.son_project_id > 0 ? true : false
            return item 
          })
          console.log(this.billList);
          this.fileList = res.itemArr.fileList.filter(item => item.file_type == '1').map((item) => {
            delete item.project_id
            delete item.create_time
            item.flist = []
            return item
          })
          this.fileList1 = res.itemArr.fileList.filter(item => item.file_type == '2').map((item) => {
            delete item.project_id
            delete item.create_time
            item.flist = []
            return item
          })
          //防空情况
          if (this.sonList.length === 0) {
            this.sonList = [{ contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', amount: '', son_id: '', sonBillList: [], bill_id: '', }]
          }
          if (this.fileList.length === 0) {
            this.fileList = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
          }
          if (this.fileList1.length === 0) {
            this.fileList1 = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
          }
          this.form = form
          this.amountChange()
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateProject()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    changeBillIdList(v, item) {
      console.log(v, item);
      for (let i = 0; i < this.billList.length; i++) {
        let ele_b = this.billList[i];
        for (let j = 0; j < v.length; j++) {
          const ele_v = v[j];
          if (ele_b.id == ele_v.id) {
            ele_b.chosed = true
          }
        }
      }
    },
    removeTag(v, item) {
      console.log(v, item);
      for (let k = 0; k < this.billList.length; k++) {
        let billitem = this.billList[k];
        if (v.id == billitem.id) {
          billitem.chosed = false
        }
      }
      for (let i = 0; i < this.sonList.length; i++) {
        const newList = this.sonList[i].sonBillList;
        for (let j = 0; j < newList.length; j++) {
          const ele = newList[j];
          if (v.id == ele.id) {
            delete this.sonList[i].sonBillList[j]
          }
        }
      }
    },
    addUpdateProject() {
      this.form.project_id = this.query.id || ''
      this.form.option = this.form.id ? '2' : '1'
      const flag = this.containsDuplicate(this.sonList, 'contract_name')
      if (flag) {
        this.$message.error('子项目名称不可重复')
        return false
      }
      if (this.amount_left != '0.00') {
        this.$message.error('子项目金额不等于合同金额')
        return false
      }
      // 替换掉id为son_id
      let $sonList = this.sonList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['son_id'] = item[key] || 0
            delete item[key]
          }
        })
        item.bill_id = (item.sonBillList.map((item) => { return item.id })).toString()
        return item
      })
      $sonList = $sonList.map(({contract_name, start_time, end_time, amount, son_id , bill_id}) => {
        return {contract_name, start_time, end_time, amount, son_id , bill_id}
      })
      const tempForm = JSON.parse(JSON.stringify(this.form))
      delete tempForm.fileList
      delete tempForm.status
      this.$fly
        .post('apiProject_addUpdate.html', {
          ...tempForm,
          son_str: JSON.stringify($sonList),
          son_del: this.del_son_list.toString(),
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          this.$router.go(-1)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    .ntitle {
      display: inline-block;
      margin: 0 0 25px 0;

      &::before {
        width: 100%;
      }
    }

    ul {
      @extend %start;
      color: var(--text-1); /* 0819修改 */;
      background: var(--bg-soft); /* 0819修改 */
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }

          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }
        }
      }
    }

  }
}
</style>